import {
  TransactionItem,
  TransactionState,
} from '../../../../codegen/transactions';
import { SidebarRow } from '../../../../components/sidebar/SidebarRow';
import { FormattedNumber } from 'react-intl';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import {
  TRANSACTION_PRODUCT_TO_TRANSLATION_KEY,
  UNIT_TYPE_TO_TRANSLATION_KEY,
} from '../../../../i18n/enumMappings';
import { MonetaryValue } from '../../../../components/MonetaryValue';

import { weaklyDisplayMonetaryAmounts } from '../../../../models';

type TransactionItemTableProps = {
  item: TransactionItem;
  transactionState: TransactionState;
};

export const TransactionItemTable = ({
  item,
  transactionState,
}: TransactionItemTableProps) => {
  const weaklyDisplayAmounts = weaklyDisplayMonetaryAmounts(transactionState);

  return (
    <div
      data-testid={'transactions-sidebar-item'}
      className={'margin-top-20 margin-bottom-20'}
    >
      <table className="table table-condensed">
        <colgroup>
          <col className="width-150" />
          <col />
        </colgroup>
        <tbody>
          <SidebarRow
            label="common.transaction.product"
            show={!!item.product}
          >
            {item.product && (
              <CustomFormattedMessage
                id={TRANSACTION_PRODUCT_TO_TRANSLATION_KEY[item.product]}
              />
            )}
          </SidebarRow>
          <SidebarRow label="common.transaction.details">
            {item.description}
          </SidebarRow>
          <SidebarRow label="common.transaction.quantity">
            <FormattedNumber
              value={parseFloat(item.quantity)}
              maximumFractionDigits={2}
              minimumFractionDigits={2}
            />
          </SidebarRow>
          <SidebarRow label="common.transaction.unit">
            <CustomFormattedMessage
              id={UNIT_TYPE_TO_TRANSLATION_KEY[item.unit]}
            />
          </SidebarRow>
          <SidebarRow
            label="common.transaction.itemPriceGross"
            fadeValue={weaklyDisplayAmounts}
          >
            <MonetaryValue
              amount={parseFloat(item.deliveryUnitAmount.amountGross)}
              currency={item.deliveryUnitAmount.currency}
              strikethrough={weaklyDisplayAmounts}
            />
          </SidebarRow>
          <SidebarRow
            label="common.transaction.inclTax"
            labelValues={{ vat: `${item.vatRate}` }}
            fadeValue={weaklyDisplayAmounts}
          >
            <MonetaryValue
              amount={parseFloat(item.deliveryUnitAmount.amountVat)}
              currency={item.deliveryUnitAmount.currency}
              strikethrough={weaklyDisplayAmounts}
            />
          </SidebarRow>
        </tbody>
      </table>
    </div>
  );
};
